module.exports = __webpack_public_path__ + "static/media/track.4db91816.svg";